import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";

const brandMenuItems = [
  { title: "DTC", path: "/brands/dtc" },
  { title: "Walmart", path: "/brands/walmart" },
  { title: "Amazon", path: "/brands/amazon" },
];

const Navbar: React.FC = () => {
  const labels = useMemo(
    () => [
      // { id: 1, title: "Home", path: "/" },
      { id: 2, title: "Apparel", path: "/apparel" },
      { id: 3, title: "Computers", path: "/computers" },
      { id: 4, title: "Gifts", path: "/gifts" },
      { id: 5, title: "Brands", path: "/brands/dtc" },
      { id: 6, title: "Others", path: "/others" },
    ],
    [],
  );
  const location = useLocation();

  const getNavItemClass = (active: boolean) =>
    `flex items-center justify-center ${
      active
        ? "text-yellow-300 font-bold border-b-2 border-yellow-300"
        : "hover:text-yellow-300 font-bold hover:border-b-2 hover:border-yellow-300"
    }`;

  return (
    <>
      <div className="w-full flex justify-center">
        <div className="w-full max-w-[600px] flex items-center md:ml-4 bg-slate-0">
          <ul className="w-full flex items-center justify-center gap-x-6 md:gap-x-10 lg:gap-x-[72px] text-sm md:text-base font-semibold text-white cursor-pointer">
            {labels.map((label, id) => {
              if (label.title === "Brands") {
                const isBrandsActive = location.pathname.startsWith("/brands");

                return (
                  <li
                    key={id}
                    className={`relative group ${getNavItemClass(isBrandsActive)}`}
                  >
                    <Link
                      to={label.path}
                      className="flex items-center gap-x-[2px]"
                    >
                      {label.title}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                      >
                        <path d="m6 9 6 6 6-6" />
                      </svg>
                    </Link>
                    {/*   */}
                    <div className="absolute left-1/2 -translate-x-1/3 top-full z-50 hidden pt-2 group-hover:block">
                      <ul className="min-w-[120px] overflow-hidden rounded-md bg-[#dc2626] py-2 px-0 shadow-lg transition-all duration-300">
                        {brandMenuItems.map((item) => (
                          <li key={item.path}>
                            <Link
                              to={item.path}
                              className={`block whitespace-nowrap px-4 py-2 text-sm font-semibold hover:text-yellow-300 hover:font-bold hover:text-base transition-all duration-300 ${
                                location.pathname === item.path
                                  ? "text-yellow-300"
                                  : "text-white"
                              }`}
                            >
                              {item.title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </li>
                );
              }

              return (
                <li
                  key={id}
                  className={getNavItemClass(location.pathname === label.path)}
                >
                  <Link to={label.path}>{label.title}</Link>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Navbar;
